'use client';

import { ChakraProvider  } from '@chakra-ui/react';
import type { ChakraProviderProps } from '@chakra-ui/react';

export function Provider({ children, value, ...props }: ChakraProviderProps) {
	return (
		<ChakraProvider value={value} {...props}>
			{children}
			{/* <ColorModeProvider {...props} /> */}
		</ChakraProvider>
	);
}
